export default "__VITE_ASSET__BwpPQewJ__"